
import { useCurrentUserRole, UserRole } from './useCurrentUserRole';
import { useUsersWithRoles, UserWithRole } from './useUsersWithRoles';
import { useUserRoleMutations } from './useUserRoleMutations';
import { useUserManagementMutations } from './useUserManagementMutations';

export type { UserRole, UserWithRole };

export const useUserRoles = () => {
  const { data: currentUserRole, isLoading: currentUserRoleLoading } = useCurrentUserRole();
  const { data: users, isLoading, error: usersError } = useUsersWithRoles(currentUserRole);
  const roleMutations = useUserRoleMutations();
  const managementMutations = useUserManagementMutations();

  return {
    currentUserRole,
    currentUserRoleLoading,
    users,
    isLoading,
    usersError,
    ...roleMutations,
    ...managementMutations,
  };
};
